/**
 * Builds the outlet `patientIntakeData` shape for JustMeds without calling GET /patient-intake
 * (avoids schedule/slot computation). Uses the same `parent_id` / `company` as global-data.
 *
 * @param {Record<string, unknown>} globals — Redux globals slice from getGlobalData
 * @returns {Record<string, unknown>}
 */
export function buildJustmedsPatientIntakeDataFromGlobals(globals = {}) {
	const ti = globals?.tenant_info || {};
	return {
		parent_id: ti.parent_id,
		company: ti.company,
		enable_calendar_slot: false,
	};
}
